"use strict";
/**
 * @module Services.SessionTrees
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var branch_mapping_table_1 = require("./../../features/session-trees/branch-mapping-table");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
function writeBranchMapping(bos, branchMapping) {
    Codec.writeString(bos, branchMapping.sessionFilter);
    Codec.writeString(bos, branchMapping.topicTreeBranch);
}
function readBranchMapping(bis) {
    var sessionFilter = Codec.readString(bis);
    var topicTreeBranch = Codec.readString(bis);
    return {
        sessionFilter: sessionFilter,
        topicTreeBranch: topicTreeBranch
    };
}
/**
 * Serialiser for {@link BranchMappingTable}
 */
var BranchMappingTableSerialiserClass = /** @class */ (function (_super) {
    __extends(BranchMappingTableSerialiserClass, _super);
    function BranchMappingTableSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link BranchMappingTable} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link BranchMappingTable} that was read
     */
    BranchMappingTableSerialiserClass.prototype.read = function (bis) {
        var sessionTreeBranch = Codec.readString(bis);
        var branchMappings = Codec.readCollection(bis, readBranchMapping);
        return new branch_mapping_table_1.BranchMappingTableImpl(sessionTreeBranch, branchMappings);
    };
    /**
     * Write a {@link BranchMappingTable} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link BranchMappingTable} to be written
     */
    BranchMappingTableSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.getSessionTreeBranch());
        Codec.writeCollection(bos, value.getBranchMappings(), writeBranchMapping);
    };
    return BranchMappingTableSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.BranchMappingTableSerialiserClass = BranchMappingTableSerialiserClass;
/**
 * The {@link BranchMappingTableSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.BranchMappingTableSerialiser = new BranchMappingTableSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-trees/branch-mapping-table-serialiser.js
// module id = 2020
// module chunks = 1